import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74497c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createTextVNode(" 亲爱的六律小伙伴："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 请完善您的个人资料，以方便我们给您推送相关业务数据和预警消息 ")
], -1))
const _hoisted_3 = { class: "content" }

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  Form,
  Button,
  Field,
  CellGroup,
  Popup,
  showToast,
  Picker,
  showSuccessToast,
  showFailToast,
} from "vant";
import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();
const name = ref("");
const tel = ref("");
const wechatAccount = ref("");
const department = ref("");
const loading = ref(false);

const showPicker = ref(false);
const columns = ref([]);
const onConfirm = ({ selectedValues, selectedOptions }: any) => {
  department.value = selectedValues[0];
  showPicker.value = false;
};
const handleSubmit = async (values) => {
  console.log("submit", values);
  const res = await request({
    url: "/api/wx/user/updateWxUser",
    method: "POST",
    data: {
      name: name.value,
      openId: sessionStorage.getItem("openid"),
      phone: tel.value,
      department: department.value,
      wechatNum: wechatAccount.value
    },
  });
  if (res.code === 200) {
    showSuccessToast("保存成功！");
    router.push("/success");
  } else {
    showFailToast(res.data);
  }
};

const getUserInfo = async () => {
  const res = await request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    if(res?.data?.name) {
      router.push("/success");
    }
  } else {
    showFailToast(res.data);
  }
};
getUserInfo();

const deptList = async () => {
  const res = await request({
    url: `/api/wx/user/select-dept`,
    method: "GET",
  });
  if (res.code === 200) {
    columns.value = res.data;
  } else {
    showFailToast(res.data);
  }
};
deptList();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Form), { onSubmit: handleSubmit }, {
        default: _withCtx(() => [
          _createVNode(_unref(CellGroup), null, {
            default: _withCtx(() => [
              _createVNode(_unref(Field), {
                modelValue: name.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                maxlength: "6",
                label: "姓名",
                placeholder: "请输入您的真实姓名",
                rules: [{ required: true, message: '请输入您的真实姓名' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                label: "手机号",
                modelValue: tel.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tel).value = $event)),
                type: "tel",
                maxlength: "11",
                placeholder: "请输入您常用的手机号",
                rules: [{ required: true, message: '请输入正确的手机号' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                label: "微信号",
                modelValue: wechatAccount.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((wechatAccount).value = $event)),
                maxlength: "30",
                placeholder: "请输入您的微信号",
                rules: [{ required: true, message: '请输入您的微信号' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                modelValue: department.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((department).value = $event)),
                "is-link": "",
                readonly: "",
                label: "所属部门",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showPicker.value = true)),
                placeholder: "请选择您所在的部门",
                rules: [{ required: true, message: '请选择您所在的部门' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Popup), {
                show: showPicker.value,
                "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showPicker).value = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Picker), {
                    columns: columns.value,
                    "columns-field-names": {
                text: 'department',
                value: 'department',
              },
                    onConfirm: onConfirm,
                    onCancel: _cache[5] || (_cache[5] = ($event: any) => (showPicker.value = false))
                  }, null, 8, ["columns"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            style: _normalizeStyle({ margin: '1.5rem' })
          }, [
            _createVNode(_unref(Button), {
              block: "",
              round: "",
              color: "#3DABA3",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("提 交")
              ]),
              _: 1
            })
          ], 4)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})